import React from "react";
import profilePhoto from "../../../assets/images/card-profile.png";
import profileBg from "../../../assets/images/bg-app.png";
import { Link } from "react-router-dom";


const CardContent = () => {
    return (
        <div className="card-content-wrapper">
            <div className="card-edit-screen">
                <div className="ces-header">
                    <div className="ces-header-photos">
                        <div className="ces-cover-photo">
                            <img src={profileBg} alt="cover photo" />
                        </div>
                        <div className="ces-profile-photo">
                            <img src={profilePhoto} alt="profile photo" />
                        </div>
                    </div>
                    <div className="ces-header-info">
                        <div className="ces-user-name edit-btn">
                            Lisa Carothers
                        </div>
                        <div className="ces-user-title edit-btn">
                            Harold Powell
                        </div>
                        <div className="ces-user-address edit-btn">
                            New York
                        </div>
                    </div>
                    <div className="ces-header-action">
                        <div className="cha-header">
                            <h4>Header action</h4>
                            <div className="ces-custom-icon">
                                <button>Custom <i className="ri-arrow-right-s-fill"></i></button>
                            </div>
                        </div>
                        <ul>
                            <li><i className="ri-phone-line"></i></li>
                            <li><i className="ri-mail-line"></i></li>
                            <li><i className="ri-whatsapp-line"></i></li>
                            <li><i className="ri-global-line"></i></li>
                        </ul>
                    </div>
                </div>
                <div className="ces-widget-wrapper">
                    <div className="ces-single-widget widget-tab">
                        <div className="ces-tab">
                            <h3 className="ces-tab-title">History <i className="ri-arrow-down-s-line"></i></h3>
                            <div className="ces-tab-content">

                            </div>
                        </div>
                    </div>
                    <div className="ces-add-widget">
                        <i className="ri-add-large-line"></i>
                        <span>Add new widget</span>
                    </div>
                </div>
                <div className="ces-footer">
                    <div className="ces-header-action">
                        <div className="cha-header">
                            <h4>Footer action</h4>
                            <div className="ces-custom-icon">
                                <button>Custom <i className="ri-arrow-right-s-fill"></i></button>
                            </div>
                        </div>
                        <ul>
                            <li><i className="ri-phone-line"></i></li>
                            <li><i className="ri-mail-line"></i></li>
                            <li><i className="ri-whatsapp-line"></i></li>
                            <li><i className="ri-add-line"></i></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CardContent;
